import axios from 'axios'
import { API_BASE_URL } from '../globalVar'

let baseUrl = API_BASE_URL
//let baseUrl = process.env.VUE_APP_API_BASE_URL

export const recentClaimApiService = {
    getForLoggedOnUser
}

function getForLoggedOnUser() {
    return axios.get(baseUrl + '/api/admin/v1/claims/recentClaimsForUser')
}
